"use client";

import { Button } from "@ac-expo/ui-components";
import { GoogleLogoIcon } from "@phosphor-icons/react";
import { authClient } from "@web-app/src/services/auth-client";
import { getSsoCallbackURL } from "@web-app/src/services/sso-callback";
import { useState } from "react";

type Props = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
  redirectPath?: string | null;
  openCart?: boolean;
};

export const GoogleLoginButton = ({
  onSuccess,
  onError,
  redirectPath,
  openCart,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    try {
      const { error } = await authClient.signIn.social({
        provider: "google",
        callbackURL: getSsoCallbackURL(redirectPath, { openCart }),
      });
      if (error) {
        onError?.(new Error(error.message));
        return;
      }
      onSuccess?.();
    } catch (error) {
      onError?.(error instanceof Error ? error : new Error("Unexpected error"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handleGoogleLogin}
      variant="outline"
      size="lg"
      className="w-full"
      disabled={isLoading}
    >
      <GoogleLogoIcon className="mr-2 h-5 w-5" weight="bold" />
      {isLoading ? "Connexion..." : "Continuer avec Google"}
    </Button>
  );
};
